// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerPackageResponse

import { hydratePayment, type Payment, type PaymentApiResponse } from './payment.gen';
import { hydrateCustomerPackageComposition, type CustomerPackageComposition, type CustomerPackageCompositionApiResponse } from './customerPackageComposition.gen';
import { hydrateCustomer, type Customer, type CustomerApiResponse } from './customer.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type CustomerPackageApiResponse = {
	id: string;
	customerId: string;
	packageId: string | null;
	packageName: string | null;
	price: number;
	createdAt: string;
	expiresOn: string | null;
	orderId: string | null;
	payment: PaymentApiResponse | null;
	compositions: CustomerPackageCompositionApiResponse[];
	customer: CustomerApiResponse | null;
	archivedAt: string | null;
};

export type CustomerPackage = {
	id: string;
	customerId: string;
	packageId: string | null;
	packageName: string | null;
	price: number;
	createdAt: DateTime;
	expiresOn: DateTime | null;
	orderId: string | null;
	payment: Payment | null;
	compositions: CustomerPackageComposition[];
	customer: Customer | null;
	archivedAt: DateTime | null;
};

export function hydrateCustomerPackage(data: CustomerPackageApiResponse): CustomerPackage {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		expiresOn: DateTimefromISO(data.expiresOn),
		payment: data.payment ? hydratePayment(data.payment) : null,
		compositions: data.compositions.map(hydrateCustomerPackageComposition),
		customer: data.customer ? hydrateCustomer(data.customer) : null,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}